// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"c2f09388","296":"ec42da85"}[chunkId] + ".chunk.css";
};